module.exports = __webpack_public_path__ + "img/deactivate-card.34618b12.svg";